import { Component, OnInit, OnChanges, Input, Inject } from '@angular/core';
import { UiService } from 'src/app/services/ui.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { min } from 'rxjs/operators';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';

@Component({
    selector: 'button-list-dialog',
    template: `
  <dialog-wrapper
    [backgroundColor]="data.color"
    [dialogTitle]="data.title || ''"
    [smallTitle]="!data.color"
    [titleHeight]="40"
    [giveMeTen]="true"
    [tiny]="true"
    [hideBottom]="!data.successLabel && !data.cancelLabel"
    [successLabel]="data.successLabel || ''"
    [cancelLabel]="data.cancelLabel || ''"
    [disabled]="!data.selected"
    [cancelDisabled]="!data.selected"
    [cancelLeft]="true"
    [maxHeight]="maxHeight"
    [showClose]="true"
    (cancel)="cancel()"
    (submit)="submit()"
    (close)="dialogRef.close()">
    <div class="items">
      <div *ngFor="let choice of choices"
        class="item"
        [ngClass]="{selected: choice[selectedKey] === data.selected}" 
        (click)="choose(choice[selectedKey])"  
      >
        <div class="name-holder">
          <div class="name">{{ choice[choiceKey] }}</div>
          <div *ngIf="secondaryKey && choice[secondaryKey]" class="secondary">{{ choice[secondaryKey] }}</div>
        </div>
        
        <div style="flex:1"></div>
        <icon class="check" icon="tick_24px"></icon>
      </div>
    </div>
  </dialog-wrapper>
  `,
    styleUrls: ['./buttonList.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule, DialogWrapperComponent],
})


export class ButtonListDialogComponent<T> implements OnInit {
  choices: T[] = []
  selectedKey: keyof T
  choiceKey: keyof T
  secondaryKey: keyof T
  maxHeight: string

  constructor(
    public dialogRef:MatDialogRef<ButtonListDialogComponent<T>>,
    public uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data:ButtonListData<T>,
  ) {
    console.log(this.data)
    this.choices = data.choiceObjects
    this.selectedKey = data.selectedKey
    this.choiceKey = data.choiceKey
    this.secondaryKey = data.secondaryChoiceKey
    console.log({ selected:data.selected});
  }

  choose(id: T[keyof T]) {
    this.data.selected = this.data.selected === id ? null : id
    console.log(id, this)
    // this.close()
  }

  submit() {
    this.data.submitted = true
    this.close()
  }

  cancel() {
    this.data.cancelled = true
    this.close()
  }

  close() {
    this.dialogRef.close({ cancelled: this.data.cancelled, submitted: this.data.submitted, selected: this.data.selected })
  }

  ngOnInit() {
    let { x, y } = this.data
    // console.log({ x, y })
    if (y && document.body.clientHeight - y < 400) {
      y = Math.max(1, document.body.clientHeight - 400);
    }
    // console.log({ x, y })
    if (x && y) this.dialogRef.updatePosition({ top: y + 'px', left: x + 'px' });
    console.log({ y, clientHeight: document.body.clientHeight })
    this.maxHeight = `${ Math.min(60 + this.choices.length*38, document.body.clientHeight - y - 20 - 60)}px`
  }

}

export interface ButtonListData<T> {
  x?: number
  y?: number
  choiceObjects?: T[]
  choiceKey?: keyof T
  secondaryChoiceKey?: keyof T
  selectedKey?: keyof T
  title?: string
  color?: string
  selected?: T[keyof T]

  successLabel?: string
  cancelLabel?: string

  submitted?: boolean
  cancelled?: boolean

}


